import { createAnatomy as m } from "../../anatomy/dist/index.mjs";
import { createScope as l } from "../../dom-query/dist/index.mjs";
import { createProps as o } from "../../types/dist/index.mjs";
var a = m("file-upload").parts(
  "root",
  "dropzone",
  "item",
  "itemDeleteTrigger",
  "itemGroup",
  "itemName",
  "itemPreview",
  "itemPreviewImage",
  "itemSizeText",
  "label",
  "trigger"
);
a.build();
var r = l({
  getRootId: (e) => {
    var i;
    return ((i = e.ids) == null ? void 0 : i.root) ?? `file:${e.id}`;
  },
  getDropzoneId: (e) => {
    var i;
    return ((i = e.ids) == null ? void 0 : i.dropzone) ?? `file:${e.id}:dropzone`;
  },
  getHiddenInputId: (e) => {
    var i;
    return ((i = e.ids) == null ? void 0 : i.hiddenInput) ?? `file:${e.id}:input`;
  },
  getTriggerId: (e) => {
    var i;
    return ((i = e.ids) == null ? void 0 : i.trigger) ?? `file:${e.id}:trigger`;
  },
  getLabelId: (e) => {
    var i;
    return ((i = e.ids) == null ? void 0 : i.label) ?? `file:${e.id}:label`;
  },
  getItemId: (e, i) => {
    var t, d;
    return ((d = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : d.call(t, i)) ?? `file:${e.id}:item:${i}`;
  },
  getItemNameId: (e, i) => {
    var t, d;
    return ((d = (t = e.ids) == null ? void 0 : t.itemName) == null ? void 0 : d.call(t, i)) ?? `file:${e.id}:item-name:${i}`;
  },
  getItemSizeTextId: (e, i) => {
    var t, d;
    return ((d = (t = e.ids) == null ? void 0 : t.itemSizeText) == null ? void 0 : d.call(t, i)) ?? `file:${e.id}:item-size:${i}`;
  },
  getItemPreviewId: (e, i) => {
    var t, d;
    return ((d = (t = e.ids) == null ? void 0 : t.itemPreview) == null ? void 0 : d.call(t, i)) ?? `file:${e.id}:item-preview:${i}`;
  },
  getHiddenInputEl: (e) => r.getById(e, r.getHiddenInputId(e)),
  getDropzoneEl: (e) => r.getById(e, r.getDropzoneId(e))
});
o()([
  "accept",
  "allowDrop",
  "capture",
  "dir",
  "directory",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "locale",
  "maxFiles",
  "maxFileSize",
  "minFileSize",
  "name",
  "onFileAccept",
  "onFileReject",
  "onFileChange",
  "required",
  "translations",
  "validate"
]);
o()(["file"]);
export {
  a as anatomy
};
